export const CHECKLIST_ITEMS = {
	moveInDate: 'The date you’re moving into your new property.',
	moveOutDate: 'The date you’re moving out of your property.',
	customerNumber: 'Your customer number.',
	emailAddress: 'Your email address.',
	lastNameOnBill: 'Your last name as shown on the bill.',
	meterReadingIfAvailable: 'Your meter reading, if you have one to hand.',
	meterReading: 'Your meter reading.',
	newAddress: 'Your new address.',
	oldAddress: 'Your old address.',
	paymentReference: 'Your payment reference. This is the 13 digit number on the top right of your bill.',
	bankDetails: 'Your credit or debit card details.',
} as const;
